export default {
	errors: {
		write_rejected:
			"Change rejected: you don't have permission to edit this item. Reload the page or contact support."
	},
	form: {
		required_error: 'This field is required',
		max_length_exceeded_error:
			'This field is too long ({{length}} characters max)'
	},
	legal: {
		copyright: 'Gerositus Sàrl - All rights reserved',
		i_consent: 'I consent',
		agreement_title: 'Agreement',
		agreement_content:
			'By using Gerositus, you agree to our <1>Terms & conditions</1> and <2>Privacy Policy</2>.',
		agreement_terms_conditions: 'Terms & conditions',
		agreement_privacy_policy: 'Privacy Policy',
	},
	navigation: {
		home: 'Home'
	},
	yes: 'Yes',
	no: 'No',
	not_defined: 'Not defined',
	please_wait: 'Please wait',
	search: 'Search',
	upgrade_required: 'Upgrade required',
	create_project_title: 'What would you like to achieve?',
	click_to_change: 'Click to change',
	click_to_create_one: 'Click <button>to create one</button>',
	no_goal: 'No goal',

	auth: {
		token_expiring_soon: 'Your session will expire in {{minutes}} minutes',
		token_expired:
			'Your session has expired. You will be redirected to the login page.',
		token_check_error: 'Error checking token',
		session_expiring:
			'Your session is about to expire. Please reconnect. Time remaining: {{time}}'
	},
	bot: {
		placeholder: 'Enter your question here',
		security_notice: 'Private, isolated AI. Your conversations remain confidential.'
	},
	tutorial: {
		button: 'Tutorial',
		exit_title: 'Exit tutorial',
		exit_confirm: 'Are you sure you want to exit the tutorial?'
	},
	subscription: {
		billing_monthly: 'Monthly',
		billing_yearly: 'Yearly',
		billing_yearly_save: '(save 20%)',
		choose_now: 'Choose now'
	},
	icons: {
		used: 'Used',
		unused: 'Unused'
	},
	theme: {
		selector: 'Theme selector',
		current_theme: 'Current theme',
		change_theme: 'Change theme'
	},
	no_description: 'No description',
	situation_analysis: {
		title: 'Situation analysis',
		description:
			'Automatically analyze an organization, company, or situation',
		organization_label: 'Organization / company',
		organization_placeholder: 'Name of the organization to analyze',
		subject_label: 'Subject',
		subject_placeholder: 'Subject to analyze (pre-filled with the project name)',
		launch_analysis: 'Run analysis',
		analysis_in_progress: 'Analysis in progress...',
		complete_analysis: 'Finish analysis',
		waiting_analysis: 'Waiting for analysis...',
		waiting_summary: 'Waiting for summary...',
		waiting_stakes: 'Waiting for stakes...',
		waiting_risks: 'Waiting for risks...',
		waiting_openings: 'Waiting for openings...',
		waiting_stakeholders: 'Waiting for stakeholders...',
		context_title: 'General context',
		summary_title: 'Summary',
		stakes_title: 'Stakes',
		risks_title: 'Risks',
		openings_title: 'Openings',
		stakeholders_title: 'Stakeholders',
		indicators_title: 'Success indicators',
		fishbone_title: 'Action plan',
		status: 'Status',
		likelihood: 'Likelihood',
		impact: 'Impact',
		stakeholder: {
			importance_label: 'Relative importance',
			propensity_label: 'Propensity',
			engagement_label: 'Engagement',
			importance_values: {
				low: 'Low',
				medium: 'Medium',
				high: 'High'
			},
			propensity_values: {
				green: 'Supportive',
				neutral: 'Neutral',
				orange: 'Tense',
				red: 'Adverse'
			},
			engagement_values: {
				inactive: 'Inactive',
				neutral: 'Neutral',
				low: 'Low',
				medium: 'Medium',
				high: 'Strong'
			},
			polarity_values: {
				positive: 'support',
				negative: 'opposition'
			}
		},
		risk_category_values: {
			operational: 'Operational',
			strategic: 'Strategic',
			existential: 'Existential'
		}
	},
	ai_disambiguation: {
		title: 'Quick topic check',
		checking: 'Checking the clarity of the topic before launching the analysis…',
		clear: 'Topic is clear, launching.',
		fallback_question:
			'The topic can be interpreted in several ways. Pick the one that matches, or add more detail.',
		other_label: "None of these match — I'll add more detail below",
		other_hint: 'Fill in the details, then launch the analysis.',
		precisions_label: 'Or add more detail to re-evaluate',
		precisions_placeholder: 'E.g.: sector-agnostic B2B SaaS for Swiss SMEs…',
		recheck: 'Re-check',
		confirm: 'Launch analysis'
	},
	ai_project_generation: {
		checkbox_label: 'Generate content with AI',
		checkbox_tooltip: "Uses the title, mission, description, and the scenarios you list below. Public AI search runs only after you click “Create project”.",
		title: 'Assisted Project Generation',
		go_to_project: 'Go to project',
		create_project: 'Create project',
		include_in_project_aria: 'Include this item in the project',
		creation_modal_title: 'Creating items',
		creation_progress_text: '{{current}} / {{total}} items created',
		error_title: 'Generation error',
		complete_title: 'Generation complete',
		complete_description: 'Your project has been successfully enriched. AI has identified key stakeholders, stakes, risks and openings.',
		summary_title: 'Analysis summary',
		initializing_text: 'Preparing deep analysis… This may take 6 to 10 minutes.',
		include_in_project_tooltip:
			'When checked, this item will be created in the project when you click “Create project”.',
		language_code: 'en',
		patience_with_scenarios:
			'Scenario generation is complex and may take a few minutes. Thanks for your patience.',
		patience_no_scenarios:
			'The in-depth analysis may take a few minutes. Thanks for your patience.',
		phases: {
			initializing: 'Launching',
			deep_research: 'Research',
			analyzing: 'AI Analysis',
			stakeholders: 'Stakeholders',
			stakes: 'Stakes',
			risks: 'Risks',
			openings: 'Openings',
			summary: 'Summary',
			fishbone: 'Action plan',
			entities: 'Entities',
			scenarios: 'Scenarios',
			indicators: 'Indicators',
			completed: 'Complete',
			error: 'Error'
			},
		section_title: "AI generation details",
		disclosure_public_title: "To public AI",
		disclosure_public_sub: "Web search. Receives only the neutral preview, reformulated from the fields above — no intent, no goals.",
		disclosure_private_title: "Private, isolated AI",
		disclosure_private_sub: "Runs in an isolated environment. No retraining, no data sent outside. Processes the title, mission, description and scenarios.",
		zone_public: "Sent to public AI",
		zone_private: "Private — not sent to public AIs",
		field_private_chip: "Private & secure",
		field_private_tooltip: "Processed by a private AI in an isolated environment. No retraining, no data sent outside.",
		preview_title: "Search preview",
		preview_refresh: "Regenerate preview",
		preview_hint: "Neutral reformulation of your subject — no trace of intent. This is exactly what will be sent to the public search — only after your validation.",
		preview_placeholder: "Provide at least the project title to generate the preview.",
		launch_generation: "Launch generation",
		fishbone_source: 'Source text',
		scenario_n: 'Scenario {{n}}',
		scenario_optimistic: 'Favorable',
		scenario_baseline: 'Likely',
		scenario_pessimistic: 'Unfavorable',
		scenario_pending: 'Pending',
		scenario_triggers: 'Trigger events',
		scenario_action_window: 'Action window',
		scenario_detail: 'Detailed analysis',
		dismiss: 'Dismiss AI suggestions and create project',
		save_pdf: 'Save as PDF',
		save_hint: 'You can save this analysis before entering the project.',
		scenario_impacts: 'Entity impacts',
		data: {
			scenarios: 'Scenarios',
			fishbone: 'Strategic action plan',
			indicators: 'Success indicators',
			strategic_context: 'Strategic context'
		},
		strategic_context: {
			pestel_title: 'PESTEL — Macro trends',
			porter_title: 'Porter — Sector forces',
			internal_title: 'Internal context',
			global_synthesis_title: 'Global synthesis',
			verdict: 'Verdict',
			pestel_axis: {
				political: 'Political',
				economic: 'Economic',
				social: 'Social',
				technological: 'Technological',
				environmental: 'Environmental',
				legal: 'Legal'
			},
			impact: {
				faible: 'Low',
				modere: 'Moderate',
				fort: 'Strong'
			},
			porter_force: {
				rivalry: 'Sector rivalry',
				newEntrants: 'New entrants',
				substitutes: 'Substitutes',
				suppliers: 'Supplier power',
				buyers: 'Buyer power'
			},
			scale: {
				difficult: 'Difficult',
				favorable: 'Favorable'
			},
			internal_component: {
				culture: 'Culture',
				resources: 'Resources',
				governance: 'Governance'
			},
			internal_verdict: {
				atout: 'Strength',
				fragilite: 'Weakness'
			}
		},
		detail: {
			started: 'Starting analysis…',
			query_reformulated: 'Query neutralized — search in progress…',
			stakes_done: 'Stakes extracted',
			risks_done: 'Risks extracted',
			openings_done: 'Openings extracted',
			stakeholders_done: 'Stakeholders extracted',
			summary_done: 'Summary written',
			fishbone_done: 'Action plan generated',
			structuring: 'Structuring data…'
		}
	},
	scenario_elaboration: {
		title: 'AI Scenario Elaboration',
		hypothesis: 'Hypothesis',
		initializing: 'Initializing analysis...',
		error_title: 'Elaboration error',
		complete_title: 'Elaboration complete',
		complete_description:
			'The scenario has been successfully elaborated. Changes have been applied.',
		analysis_preview: 'Preliminary analysis',
		applied_changes: 'Applied changes',
		stakeholders_modified: 'stakeholder(s) modified',
		stakes_modified: 'stake(s) modified',
		risks_modified: 'risk(s)/opening(s) modified',
		indicators_modified: 'indicator(s) modified',
		new_elements: 'new',
		steps: {
			started: 'Starting',
			started_desc: 'Initializing analysis...',
			fetching_project: 'Fetching project',
			fetching_project_desc: 'Loading project data...',
			deep_research: 'Initial analysis',
			deep_research_desc: 'Deep situational analysis...',
			ai_analysis: 'AI Analysis',
			ai_analysis_desc: 'AI is analyzing the hypothesis impact...',
			reformatting: 'Formatting',
			reformatting_desc: 'Structuring results...',
			processing_stakeholders: 'Stakeholders',
			processing_stakeholders_desc: 'Calculating stakeholder impacts...',
			processing_stakes: 'Stakes',
			processing_stakes_desc: 'Calculating stake impacts...',
			processing_risks: 'Risks',
			processing_risks_desc: 'Calculating risk impacts...',
			processing_indicators: 'Indicators',
			processing_indicators_desc: 'Calculating indicator impacts...',
			completed: 'Completed',
			completed_desc: 'Analysis completed successfully',
			error: 'Error',
			error_desc: 'An error occurred'
		}
	},
	attachments: {
		title: 'Attachments',
		privacy_chip: 'Private & secure',
		subtitle: 'Private documents (PDF, DOCX, TXT) read by the AI to enrich the analysis. Encrypted at rest, antivirus-scanned, never re-served or quoted verbatim.',
		drop_hint: 'Drop files or click to add',
		formats_hint: 'PDF, DOCX, TXT · 50 MB max',
		empty: 'No document',
		delete: 'Delete',
		submit_blocked: 'Wait for the antivirus scan of all attachments to complete before launching.',
		ready_short: 'ready',
		scanning_short: 'scan',
		count_one: '{{count}} file',
		count_other: '{{count}} files',
		status: {
			pending: 'Pending',
			scanning: 'Antivirus scan',
			ready: 'Ready',
			infected: 'Infected',
			failed: 'Scan failed'
		},
		error: {
			unsupported: 'Unsupported format',
			too_large: 'File too large (max 50 MB)',
			upload_failed: 'Upload failed',
			delete_failed: 'Could not delete'
		}
	}
};
